import { Link, NavLink, Outlet } from "react-router-dom";
import Header from "../Header";

const tabs = [
  { to: "/planet", end: true, label: "首页" },
  { to: "/planet/singles", label: "单身地图" },
  { to: "/planet/bottles", label: "漂流瓶" },
  { to: "/planet/events", label: "活动地图" },
  { to: "/planet/settings/privacy", label: "隐私" },
];

export default function PlanetLayout() {
  return (
    <div className="min-h-screen bg-slate-50 text-slate-800">
      <Header />
      <div className="border-b border-teal-100 bg-gradient-to-b from-teal-50/80 to-slate-50">
        <div className="max-w-5xl mx-auto px-4 pt-8 pb-4">
          <p className="text-xs tracking-[0.2em] uppercase text-teal-700/70 mb-1">Drift Planet</p>
          <h1 className="text-3xl font-semibold tracking-tight text-teal-950">漂流星球</h1>
          <p className="mt-2 text-sm text-slate-600 max-w-xl">
            公开模糊位置，遇见同城与远方；投一封漂流瓶，等一次真诚回信。
          </p>
          <nav className="mt-6 flex flex-wrap gap-2">
            {tabs.map((t) => (
              <NavLink
                key={t.to}
                to={t.to}
                end={t.end}
                className={({ isActive }) =>
                  `px-3 py-1.5 text-sm rounded-lg transition ${
                    isActive
                      ? "bg-teal-800 text-white"
                      : "bg-white/80 text-teal-900 border border-teal-100 hover:bg-teal-50"
                  }`
                }
              >
                {t.label}
              </NavLink>
            ))}
          </nav>
        </div>
      </div>
      <main className="max-w-5xl mx-auto px-4 py-6">
        <Outlet />
      </main>
      <footer className="max-w-5xl mx-auto px-4 pb-10 text-xs text-slate-400">
        <Link to="/" className="hover:text-teal-700">
          返回主站
        </Link>
        <span className="mx-2">·</span>
        位置仅城市级模糊展示，不用于精准婚恋匹配
      </footer>
    </div>
  );
}
